<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="my-3 mx-2">
            <div class="d-flex align-items-center my-1">
                <div class="mx-2 h3">Pages</div>
                <router-link to="/pages/add">
                    <button class="btn btn-sm border border-primary text-primary" v-if="permissions.ADD_CONTENT == 'Y'">
                        Add New Page
                    </button>
                </router-link>
            </div>
            <AllElements category_id="5" editLink="pages"></AllElements>
        </div>
    </div>
</template>
<script>
import AllElements from "@/components/ElementComponents/AllElements";

export default {
    setup() { },
    components: {
        AllElements,
    },
    mounted() {
        this.permissions = JSON.parse(localStorage.getItem("permissions"));
    },
    data() {
        return {
            permissions: {},
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'Pages',
                    to: '/pages/all'
                }, {
                    text: 'All Pages',
                    to: '/pages/all'
                }
            ],
        };
    },
};
</script>
